module.exports = __webpack_public_path__ + "img/bol.ff020f27.png";